var React = require('react');

function ArrowForward (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M9.52 9.2l-2.78 2.82c-.22.22-.34.5-.34.82 0 .3.12.6.34.82.22.22.52.34.83.34.3 0 .6-.12.82-.34l4.84-4.84c.22-.22.34-.5.34-.82 0-.3-.13-.6-.35-.82L8.4 2.34C8.16 2.12 7.87 2 7.56 2c-.3 0-.6.12-.83.34-.45.45-.45 1.2 0 1.64l2.8 2.82h-5.9c-.7 0-1.23.54-1.23 1.2 0 .67.54 1.2 1.2 1.2h5.92z"}));
}

ArrowForward.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = ArrowForward;

ArrowForward.default = ArrowForward;
